import React from 'react';
import { DataValueColorNavy, UnderlineLink } from '../../../commonStyles';
import { Count, OverView, GrantsCount, GrantsHeading } from './styles';
import Preloader from '../../../Preloader/Preloader';
import { withRouter } from 'react-router-dom';
import { selectHeader } from '../../../../actions/globalActions';
import { connect } from 'react-redux';
import {
  ContentMessage,
  Types,
} from '../../../ContentMessages';
import { recordError } from '../../../../utils/commonUtil';
import PropTypes from 'prop-types';

function goToPage(props, tab, tabName) {
  try {
    props.handleLinkAnalytics('grantOverviewTopLink', '', tabName);
    props.selectHeader('Grant Activity');
    props.history.push({
      pathname: `/grants/activity`,
      state: { grantTab: tab },
    });
  } catch (error) {
    recordError(error);
  }
}

const SummaryWeb = (props) => {
  const { accData, isLoading, grantsCount } = props;
  let grantCounts;
  if (
    isLoading === false &&
    !grantsCount.grantAgreement &&
    !grantsCount.activeSchedules &&
    !grantsCount.pendingGrant
  ) {
    grantCounts = 0;
  }
  return (
    <>
      <OverView
        grantCounts={grantCounts}
        lg={{ span: grantCounts === 0 ? '24' : '8' }}
      >
        <GrantsHeading>
          <ContentMessage
            page='Grants Overview'
            type={Types.PAGE_TITLE_DESCRIPTION}
            property='field_page_title'
            defaultMessage={<Preloader styling='btnLoader' />}
          ></ContentMessage>
        </GrantsHeading>
        <DataValueColorNavy isBreak className='mt-10'>
          {accData.accountName} - {accData.accountId}
        </DataValueColorNavy>
      </OverView>
      {isLoading ? (
        <Preloader />
      ) : (
        <Count lg={{ span: '16' }}>
          <GrantsCount>
            {grantsCount.grantAgreement !== 0 && grantsCount.grantAgreement && (
              <div>
                <span data-test='grantsWebCount'>
                  {grantsCount.grantAgreement !== null ? (
                    grantsCount.grantAgreement
                  ) : (
                    <span>&mdash;</span>
                  )}
                </span>
                <UnderlineLink
                  onClick={() => goToPage(props, '3', 'Grant Agreements')}
                  data-test='grantsDashboardAgreementClick'
                >
                  Grant Agreements
                </UnderlineLink>
              </div>
            )}
            {grantsCount.activeSchedules !== 0 && grantsCount.activeSchedules && (
              <div>
                <span>
                  {grantsCount.activeSchedules !== null ? (
                    grantsCount.activeSchedules
                  ) : (
                    <span>&mdash;</span>
                  )}
                </span>
                <a
                  onClick={() => goToPage(props, '2', 'Active Schedules')}
                  data-test='grantsDashboardSchedulesClick'
                >
                  Active Schedules
                </a>
              </div>
            )}
            {grantsCount.pendingGrant !== 0 && grantsCount.pendingGrant && (
              <div>
                <span>
                  {grantsCount.pendingGrant !== null ? (
                    grantsCount.pendingGrant
                  ) : (
                    <span>&mdash;</span>
                  )}
                </span>
                <a
                  onClick={() => goToPage(props, '1', 'Pending Grants')}
                  data-test='grantsDashboardPendingGrantsClick'
                >
                  Pending Grants
                </a>
              </div>
            )}
          </GrantsCount>
        </Count>
      )}
    </>
  );
};

const mapDispatchToProps = (dispatch) => ({
  selectHeader: (data) => dispatch(selectHeader(data)),
});

export default withRouter(connect(null, mapDispatchToProps)(SummaryWeb));

SummaryWeb.propTypes = {
  isLoading: PropTypes.bool.isRequired,
  handleLinkAnalytics: PropTypes.func,
  grantsCount: PropTypes.shape({
    activeSchedules: PropTypes.number,
    availableBalance: PropTypes.number,
    currentBalance: PropTypes.number,
    grantAgreement: PropTypes.number,
    grantIssuedYTD: PropTypes.number,
    pendingGrant: PropTypes.number,
  }),
  accData: PropTypes.shape({
    accountId: PropTypes.string,
    accountName: PropTypes.string,
    availableBalance: PropTypes.number,
    beginBalance: PropTypes.number,
    currentBalance: PropTypes.number,
    dateChanged: PropTypes.number,
    endBalance: PropTypes.number,
    grantsAndContribution: PropTypes.number,
    grantsYTD: PropTypes.number,
    marketMovement: PropTypes.number,
    roleAccess: PropTypes.string,
    ytdPercentage: PropTypes.number,
    ytdPercentageIncrease: PropTypes.bool,
  }),
};
